import { render, staticRenderFns } from "./addRewards.vue?vue&type=template&id=88a870f2&"
import script from "./addRewards.vue?vue&type=script&lang=js&"
export * from "./addRewards.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addRewards.vue?vue&type=style&index=1&id=88a870f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports